import { initAnchorNavigation } from './anchor-navigation.js';
import { initMobileNavigation } from './mobile-navigation.js';
import { initDynamicHeaderHeight } from './dynamic-header-height.js';
import { setupAnimations } from './animations.js';
import { setupStickyHeader } from './header.js';
import { setupQueryPaginationScroll, setupQueryPaginationClickScroll } from './query-pagination-scroll.js';
import { initCoverMobileBreakpoints } from './cover-mobile-breakpoint.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import { SplitText } from 'gsap/SplitText';


gsap.registerPlugin(Flip);

gsap.registerPlugin(ScrollTrigger);

window.animations = {
  gsap: gsap,
  ScrollTrigger: ScrollTrigger,
  Flip: Flip,
  SplitText: SplitText
};

// send event to the parent window, that gsap is ready and available, use events, a subscriber can listen to the event with an event listener, custom event
window.dispatchEvent(new CustomEvent("gsap-ready", {
  detail: {
    gsap: gsap,
    ScrollTrigger: ScrollTrigger,
    Flip: Flip,
    SplitText: SplitText
  }
}));

/**
 * Custom DOM ready function
 */
function onDomReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

/**
 * Application entrypoint
 */
onDomReady(() => {
  // Anchor navigation früh initialisieren (für Hash-Handling vor anderen Scripts)
  initAnchorNavigation();
  
  // Mobile Navigation initialisieren
  initMobileNavigation();
  
  // Dynamic Header Height initialisieren
  initDynamicHeaderHeight(document);
  
  setupStickyHeader();
  setupQueryPaginationScroll();
  setupQueryPaginationClickScroll();
  initCoverMobileBreakpoints();
  // Verhindere Laden im Editor
  if (!document.body.classList.contains("is-admin")) {
    setupAnimations(gsap, ScrollTrigger);
  }
});
